import { platformAccessInterceptor } from '../../core/platform-access/platform-access.interceptor';
import { ApplicationConfig, LOCALE_ID, provideZoneChangeDetection } from '@angular/core';
import { provideRouter, TitleStrategy } from '@angular/router';
import { routes } from './app.routes';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { authInterceptor } from '../../core/auth/auth.interceptor';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { importProvidersFrom } from '@angular/core';
import { getHungarianPaginatorIntl } from '../../core/layout/hungarian-paginator-intl';
import { registerLocaleData } from '@angular/common';
import localeHu from '@angular/common/locales/hu';
import { AppTitleStrategy } from './app-title.strategy';

registerLocaleData(localeHu);

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideAnimationsAsync(),
    provideHttpClient(withInterceptors([authInterceptor, platformAccessInterceptor])),
    { provide: TitleStrategy, useClass: AppTitleStrategy },
    { provide: MatPaginatorIntl, useFactory: getHungarianPaginatorIntl },
    { provide: LOCALE_ID, useValue: 'hu-HU' },
    importProvidersFrom(MatSnackBarModule),
  ],
};
